import { constants } from './constants'

const loadInit = (orderId, msisdn) => ({
  type: constants.LOAD_INIT,
  payload: {
    orderId,
    msisdn,
  },
})

const loadSucceeded = () => ({
  type: constants.LOAD_SUCCEEDED,
})

const loadFailed = error => ({
  type: constants.LOAD_FAILED,
  payload: error,
})

export const actions = {
  loadInit,
  loadSucceeded,
  loadFailed,
}
